export enum ButtonType {
	PLP = 'plp',
	CLUSTER = 'cluster',
	COMPARE = 'compare',
}
